export default __webpack_public_path__ + "static/media/pemex.12d74bc5.svg";